import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import { Routes, Route, Navigate } from "react-router";
import AccountingPage from "./pages/Contabilita";
import HelpPage from "./pages/Help";
import { Toaster } from "react-hot-toast";
import { Sidenav } from "./components/layout/Sidenav";
import Login from "./pages/Users/Login";
import Account from "./pages/Users/Account";
import RequireAuth from "./auth/RequireAuth";
import { Outlet } from "react-router";
import UploadedFilesPage from "./pages/Files";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <Routes>
        {/* Area pubblica (per ora solo login) */}
        <Route path="/login" element={<Login />} />

        {/* Area protetta: tutto il resto dell'app */}
        <Route element={<RequireAuth />}>
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Navigate to="/amministrazione/contabilita" replace />} />
            <Route path="/contabilita" element={<Navigate to="/amministrazione/contabilita" replace />} />
            <Route path="/amministrazione/contabilita" element={<AccountingPage />} />
            <Route path="/amministrazione/files" element={<UploadedFilesPage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/manuale" element={<HelpPage />} />
            <Route path="/manuale-tecnico" element={<HelpPage src="/manuale_tecnico.md" title="Manuale tecnico" />} />
          </Route>
        </Route>
      </Routes>
    </Provider>
  );
};

const ProtectedLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidenav />
      {/* ATTENZIONE: ml-72 deve corrispondere a w-72 della sidenav */}
      <div className="ml-72 flex min-h-screen flex-col">
        {/* <Header /> */}
        <main className="flex-1 p-6">
          <Outlet />
        </main>
        <Toaster />
      </div>
    </div>
  );
};

export default App;
